export default "__VITE_ASSET__bbf97eb2__"